import React from "react";
import ServicePage from "../components/ServicePage";
function ManagedITSupportPage() {
	const queryParams = new URLSearchParams(window.location.search);

	// Get a specific query parameter
	const assigned_to = queryParams.get('assigned_to');
	const event_type_name = queryParams.get('event_type_name');
	const event_start_time = queryParams.get('event_start_time');
	const invitee_full_name = queryParams.get('invitee_full_name');
	const invitee_email = queryParams.get('invitee_email');


	const d = new Date(event_start_time);

	const longDate = d.toLocaleDateString("en-US", {
		timeZone: "America/New_York",
		month: "long",
		day: "numeric",
		year: "numeric",
	});
	const shortTime = d.toLocaleTimeString("en-US", {
		timeZone: "America/New_York",
		hour: "numeric",
		minute: "2-digit",
		hour12: true,
	});

	const usLong = `${longDate} ${shortTime}`; // "August 27, 2025 4:00 PM"

	const title = "Calendly Confirmation";

	const content = {
		title: "Thank you for booking your discovery session! ",
		paragraphs: [],
		mainOffer: {
			title: "Booking Information",
			description:
				"Please check your email for a calendar invite!",
			bulletPoints: [
				`Meeting with: ${assigned_to} `,
				`Meeting type: ${event_type_name} `,
				`Meeting time: ${usLong} `,
				`Meeting invite: ${invitee_full_name} (${invitee_email}) `,
			],
			illustration: "/images/illustrations/consulting-illustration.png",
		},
	};

	const services = null;

	return <ServicePage title={title} content={content} services={services} />;
}

export default ManagedITSupportPage;
